import React from "react";
import { UserRole } from "../lib/models/enums";
import { UserContext } from "../state/user-context";

export default function useGetUserRole(): UserRole {
  const context = React.useContext(UserContext);

  if (context === undefined) {
    throw new Error("useGetUserRole must be used within a UserContextProvider");
  }

  if (context.role) {
    return context.role;
  } else return "External";
}
